import classNames from 'classnames';
import React from 'react';

import style from './CardOverlay.module.css';

export const CardLoading = () => {
  return (
    <div className={style.backgroundLoadingContainer}>
      <div
        className={classNames('absolute inset-0 z-10', style.backgroundLoading)}
      >
        <div className="text-content-complementary absolute inset-0 flex h-full flex-col items-center justify-center opacity-[1]" />
      </div>
    </div>
  );
};
